export default ['screen', 'window', 'tab', 'browser', 'application'];
